<div>
    <p-floatlabel variant="on">
        <p-iconfield>
            <input type="text" pInputText pSize="small" [value]="displayValue" (click)="openPanel($event)" readonly
                class="cursor-pointer" />
            @if (showClear && displayValue) {
            <p-inputicon class="pi pi-times cursor-pointer" (click)="onClearFromInput($event)" />
            }
        </p-iconfield>
        <label>{{ label }}</label>
    </p-floatlabel>

    <p-popover #panel>
        <div class="flex flex-column gap-3" style="min-width: 350px;">
            <!-- Sélecteur de période préprogrammée -->
            <div>
                <label class="block text-sm font-medium mb-2">Période</label>
                <p-select [(ngModel)]="selectedPeriod" [options]="periods" optionLabel="label"
                    placeholder="Sélectionner une période" (onChange)="onPeriodChange()" [style]="{'width': '100%'}" />
            </div>

            <!-- Date de début -->
            <div>
                <label class="block text-sm font-medium mb-2">Date de début</label>
                <p-datepicker [(ngModel)]="localDateFrom" dateFormat="dd/mm/yy" [showIcon]="true" [showButtonBar]="true"
                    [showClear]="showClear" (ngModelChange)="onDateFromChange()" [style]="{'width': '100%'}" />
            </div>

            <!-- Date de fin -->
            <div>
                <label class="block text-sm font-medium mb-2">Date de fin</label>
                <p-datepicker [(ngModel)]="localDateTo" dateFormat="dd/mm/yy" [showIcon]="true" [showButtonBar]="true"
                    [showClear]="showClear" (ngModelChange)="onDateToChange()" [style]="{'width': '100%'}" />
            </div>

            <!-- Bouton d'action -->
            <div class="flex justify-content-end">
                <p-button label="Effacer tout" severity="secondary" size="small" (onClick)="onClear()" />
            </div>
        </div>
    </p-popover>
</div>